import axios from "axios";

// Customer PIN sessions must not use the legacy staff token or /login redirect.
export const customerHttp = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/muzicapi/api/v2/",
  timeout: 10000,
  headers: { Accept: "application/json" },
});
export const requestCustomerPin = async (payload, signal) =>
  (await customerHttp.post("/customer/request_pin", payload, { signal })).data;
export const verifyCustomerPin = async (payload, signal) =>
  (await customerHttp.post("/customer/verify_pin", payload, { signal })).data;
export const getCustomerProfile = async (token, signal) =>
  (await customerHttp.get("/customer/profile", { signal, headers: { Authorization: `Bearer ${token}` } })).data;
export const getCustomerBranches = async (signal) =>
  (await customerHttp.get("/getbranches", { signal })).data;

export const updateCustomerProfile = async (token, payload, signal) =>
  (await customerHttp.patch("/customer/profile", payload, { signal, headers: { Authorization: `Bearer ${token}` } })).data;

export const getCustomerSongs = async (token, params, signal) =>
  (await customerHttp.get("/customer/songs", { params, signal, headers: { Authorization: `Bearer ${token}` } })).data;
